export const NO_PROTECTION_PLAN = 'No protection plan';
export const ADD_PROTECTION_PLAN = 'Add protection plan';

export const PROTECTION_PLAN_OPTIONS = [
  NO_PROTECTION_PLAN,
  ADD_PROTECTION_PLAN,
];
